import React from 'react';
import LegalLayout from '../../components/LegalLayout';

const ASA = () => (
  <LegalLayout title="UK ASA Advertising Compliance Statement" lastUpdated="1 February 2026">
    <p>MyBusinessAdPro ("<strong>MBAP</strong>") is designed to help UK small businesses produce advertising that meets the standards of the UK Advertising Standards Authority (<strong>ASA</strong>). This page explains how our built-in compliance scan works and what you, the advertiser, must still do.</p>

    <h2>1. Codes we align with</h2>
    <ul>
      <li><strong>CAP Code</strong> — non-broadcast advertising (social media, websites, email, print).</li>
      <li><strong>BCAP Code</strong> — where content is used in broadcast contexts (radio, TV).</li>
      <li><strong>Consumer Protection from Unfair Trading Regulations 2008</strong> &amp; <strong>Digital Markets, Competition and Consumers Act 2024</strong>.</li>
      <li><strong>Equality Act 2010</strong>.</li>
    </ul>

    <h2>2. What the MBAP compliance check does</h2>
    <p>Before an ad is delivered to you, our server-side scan flags common CAP-Code risk patterns, including:</p>
    <ul>
      <li>Absolute claims ("best", "#1", "guaranteed") that would need substantiation.</li>
      <li>Health, medical, slimming, or cosmetic efficacy claims without qualification.</li>
      <li>Missing price-related disclosures ("from", "+VAT", terms apply).</li>
      <li>Targeting or imagery that may be inappropriate for under-18s.</li>
      <li>Environmental claims ("eco-friendly", "green") that may require proof under the CMA Green Claims Code.</li>
    </ul>
    <p>When issues are detected, MBAP will either rewrite the copy or surface an inline warning for your review.</p>

    <h2>3. What the check does NOT do</h2>
    <p>The MBAP compliance check is <strong>assistive and probabilistic</strong>. It does not:</p>
    <ul>
      <li>Replace legal advice.</li>
      <li>Verify factual accuracy of your business claims.</li>
      <li>Check that you have substantiation documents on file.</li>
      <li>Audit your wider advertising campaign context.</li>
    </ul>
    <p>You remain solely responsible for the final advertising you publish.</p>

    <h2>4. Disclosure requirements for paid / influencer content</h2>
    <p>Under ASA guidance, clearly label advertising when:</p>
    <ul>
      <li>You are paying a third party (influencer, creator) to promote your business — they must use <code>#ad</code> prominently.</li>
      <li>You are paying for placement on Meta, TikTok, Google, etc. — most platforms auto-label these as "Sponsored".</li>
      <li>You are running a gifted product review — use <code>#gifted</code> or similar.</li>
    </ul>

    <h2>5. Keeping substantiation</h2>
    <p>The ASA may ask you to provide evidence for any factual claim within 5 working days. Keep:</p>
    <ul>
      <li>Written sources for statistics.</li>
      <li>Customer review URLs, invoices, or testimonials where relevant.</li>
      <li>Proof of qualifications, certifications, or awards you mention.</li>
      <li>Original photographs (or licences) for images used.</li>
    </ul>

    <h2>6. Reporting an ad we generated</h2>
    <p>If you believe content generated via MBAP breaches the CAP Code, please email <a href="mailto:contact@mybusinessadpro.co.uk">contact@mybusinessadpro.co.uk</a> with the ad ID and details. We will investigate and, where appropriate, update our prompts and safety filters.</p>

    <h2>7. Complaints to the ASA</h2>
    <p>Consumers or competitors who believe an ad breaches the Code can complain directly at <a href="https://www.asa.org.uk" target="_blank" rel="noopener noreferrer">asa.org.uk</a>.</p>
  </LegalLayout>
);
export default ASA;
